import { Module } from '@nestjs/common'
import { GoogleReservationsBookingServerModule } from './booking-server'
import { GoogleReservationsCronModule } from './crons'
import { GoogleReservationsProcessorModule } from './processors'

@Module({
	imports: [GoogleReservationsBookingServerModule, GoogleReservationsProcessorModule, GoogleReservationsCronModule],
})
export class GoogleReservationsModule {}
